import React, { useEffect, useState } from 'react';
import { applyPwaUpdate, getPwaUpdateState, subscribeToPwaUpdates } from '../utils/pwaUpdate';
import './PwaUpdatePrompt.css';

export default function PwaUpdatePrompt() {
  const [state, setState] = useState(getPwaUpdateState);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => subscribeToPwaUpdates((next) => {
    setState(next);
    if (!next.updateAvailable) setDismissed(false);
  }), []);
  if (!state.updateAvailable || dismissed) return null;
  return <aside className="pwa-update-prompt" role="status" aria-live="polite">
    <div><strong>Une nouvelle version d’Elakay est disponible.</strong><span>La mise à jour sera appliquée quand vous la confirmerez.</span></div>
    <div>
      <button type="button" className="secondary" onClick={() => setDismissed(true)}>Plus tard</button>
      <button type="button" onClick={applyPwaUpdate} disabled={state.applying}>{state.applying ? 'Mise à jour…' : 'Mettre à jour'}</button>
    </div>
  </aside>;
}
